import { Button } from '@mui/material';

import { ButtonGroupButtonProps } from './ButtonGroupButton.types';

export const ButtonGroupButton = ({ isActive, text, onClick }: ButtonGroupButtonProps) => (
  <Button variant={isActive ? 'contained' : 'outlined'} onClick={onClick} disabled={isActive}>
    {text}
  </Button>
);
